// @ts-nocheck
import { MenuItem, Select } from "@mui/material";
import PropTypes from "prop-types";
import { getCssVariableHandler } from "../../../utils/styles/getCssVariables";
import { infinity } from "../../../utils/values/infinity";

const RowsPerPageDropdown = ({ value, onChange, show15 = false }) => {
  return (
    <Select
      sx={{
        height: "2rem",
        color: getCssVariableHandler({
          variableName: "--font-rgb",
        }),
        border: `0.5px solid ${getCssVariableHandler({
          variableName: "--font-rgb",
        })}`,
        ".MuiSvgIcon-root": {
          fill: `${getCssVariableHandler({ variableName: "--font-rgb" })} !important`,
        },
        outline: "none",
        "& .MuiOutlinedInput-notchedOutline": {
          border: "none",
        },
        "&.Mui-focused": {
          outline: "none",
          border: `0.5px solid ${getCssVariableHandler({ variableName: "--font-rgb" })}`,
        },
        "& .MuiSelect-select": {
          paddingTop: "0px", // Prevents vertical movement
          paddingBottom: "0px",
        },
      }}
      defaultValue={value}
      value={value}
      onChange={(e) => {
        if (onChange) {
          onChange(e);
        }
        // setRowsPerPage(e.target.value);
      }}
    >
      <MenuItem key={5} value={5}>
        5
      </MenuItem>
      <MenuItem key={10} value={10}>
        10
      </MenuItem>
      {show15 ? (
        <MenuItem key={15} value={15}>
          15
        </MenuItem>
      ) : null}
      <MenuItem key={25} value={25}>
        25
      </MenuItem>
      <MenuItem key={50} value={50}>
        50
      </MenuItem>
      <MenuItem key={100} value={100}>
        100
      </MenuItem>
      <MenuItem key={infinity} value={infinity}>
        All
      </MenuItem>
    </Select>
  );
};

RowsPerPageDropdown.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func,
  show15: PropTypes.bool,
};

export default RowsPerPageDropdown;